import axios from 'axios';

const SuperAdminService = {
  async getOrganizations(params = {}) {
    const response = await axios.get('/super-admin/organizations', {
      params,
    });
    return response.data;
  },

  async getOrganization(organizationId) {
    const response = await axios.get(`/super-admin/organizations/${organizationId}`);
    return response.data;
  },

  async createOrganization(payload) {
    const response = await axios.post('/super-admin/organizations', payload);
    return response.data;
  },

  async updateOrganization(organizationId, payload) {
    const response = await axios.patch(
      `/super-admin/organizations/${organizationId}`,
      payload
    );
    return response.data;
  },

  async deleteOrganization(organizationId, payload) {
    const response = await axios.delete(`/super-admin/organizations/${organizationId}`, payload ? { data: payload } : undefined);
    return response.data;
  },

  async getOrgRoles() {
    const response = await axios.get('/super-admin/org-roles');
    return response.data;
  },

  async getUsers(params = {}) {
    const response = await axios.get('/super-admin/users', {
      params,
    });
    return response.data;
  },

  async getUser(userId) {
    const response = await axios.get(`/super-admin/users/${userId}`);
    return response.data;
  },

  async createUser(payload) {
    const response = await axios.post('/super-admin/users', payload);
    return response.data;
  },

  async updateUser(userId, payload) {
    const response = await axios.patch(`/super-admin/users/${userId}`, payload);
    return response.data;
  },

  async deleteUser(userId) {
    const response = await axios.delete(`/super-admin/users/${userId}`);
    return response.data;
  },

  async destroyUser(userId, payload) {
    const response = await axios.delete(
      `/super-admin/users/${userId}/destroy`,
      payload ? { data: payload } : undefined
    );
    return response.data;
  },

  async resetUserPassword(userId) {
    const response = await axios.post(`/super-admin/users/${userId}/reset-password`);
    return response.data;
  },

  async startImpersonation(organizationId, orgRoleAccess) {
    const response = await axios.post('/super-admin/impersonations', {
      organizationId,
      orgRoleAccess,
    });
    return response.data;
  },

  async endImpersonation() {
    const response = await axios.delete('/super-admin/impersonations');
    return response.data;
  },

  async getOrganizationStorage(organizationId) {
    const response = await axios.get(`/super-admin/organizations/${organizationId}/storage`);
    return response.data;
  },

  async getSupportTickets(params = {}) {
    const response = await axios.get('/super-admin/support/tickets', { params });
    return response.data;
  },

  async getSupportTicket(ticketId) {
    const response = await axios.get(`/super-admin/support/tickets/${ticketId}`);
    return response.data;
  },

  async replySupportTicket(ticketId, payload) {
    const response = await axios.post(
      `/super-admin/support/tickets/${ticketId}/reply`,
      payload
    );
    return response.data;
  },

  async deleteSupportTicket(ticketId) {
    const response = await axios.delete(`/super-admin/support/tickets/${ticketId}`);
    return response.data;
  },
};

export default SuperAdminService;
